import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, watch } from "vue";
import { RouteRecordRaw } from "vue-router";

import { routes } from "@/router/routes";
import { usePermissions } from "@/use/usePermissions";
import { useStore } from "@/use/useStore";

import UiTabbar from "@/plugins/ui/components/tabbar/UiTabbar.vue";
import UiTabbarItem from "@/plugins/ui/components/tabbar/UiTabbarItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTabbar',
  setup(__props) {

const { currentUser } = useStore();
const { isAllow } = usePermissions();

const availableRoutes = ref<RouteRecordRaw[]>([]);

function calculateRoutes() {
  const routesSize = routes.length > 5 ? 4 : 5;

  const filteredRoutes = [...routes].filter((route) => {
    if (route.meta?.hidden === true) {
      return;
    }

    let priority = route.meta?.priority;

    if (route.meta?.allowFor && !isAllow(route.meta.allowFor)) {
      return;
    }

    if (route.meta?.allowFor && !isAllow(route.meta.allowFor) && priority) {
      priority = (1000 - priority) * -1;
    }

    return { ...route, meta: { ...route.meta, priority } };
  });

  availableRoutes.value = filteredRoutes.slice(0, routesSize);
}

watch(() => currentUser.value?.id, calculateRoutes, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UiTabbar, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoutes.value, (route) => {
        return (_openBlock(), _createBlock(UiTabbarItem, {
          key: route.path,
          onClick: ($event: any) => (_ctx.$router.replace(route.path)),
          active: _ctx.$route.path === route.path,
          icon: route.meta?.icon,
          title: route.meta?.tiny_title
        }, null, 8, ["onClick", "active", "icon", "title"]))
      }), 128)),
      _createVNode(_component_router_link, {
        to: "/more",
        custom: ""
      }, {
        default: _withCtx(({ navigate, isActive }) => [
          _createVNode(UiTabbarItem, {
            onClick: ($event: any) => (navigate()),
            active: isActive,
            icon: "Menu",
            title: "Ещё"
          }, null, 8, ["onClick", "active"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})